import { render, staticRenderFns } from "./Scheme3.vue?vue&type=template&id=3e22def0&scoped=true"
import script from "./Scheme3.vue?vue&type=script&lang=js"
export * from "./Scheme3.vue?vue&type=script&lang=js"
import style0 from "./Scheme3.vue?vue&type=style&index=0&id=3e22def0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e22def0",
  null
  
)

export default component.exports